/**
 * Node kinds and shapes.
 *
 * Kind is semantic — what the node *is*, which decides how it is edited, exported, indexed and
 * read aloud. Shape is presentation. They are separate because a checklist drawn as a cloud is
 * still a checklist, and export and search must both know that.
 */
export const NODE_TYPES = [
    'text',
    'card',
    'image',
    'video',
    'audio',
    'document',
    'table',
    'checklist',
    'radio-list',
    'location',
    'group',
    'note',
    'code',
    'formula',
];
export const NODE_SHAPES = [
    'rectangle',
    'rounded-rectangle',
    'square',
    'circle',
    'ellipse',
    'capsule',
    'diamond',
    'hexagon',
    'octagon',
    'cloud',
    'card',
    'sticky-note',
    'balloon',
    'invisible-frame',
];
export const DEFAULT_NODE_TYPE = 'text';
export const DEFAULT_NODE_SHAPE = 'rounded-rectangle';
//# sourceMappingURL=node.js.map